import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IrGeneratorApi } from '../api/ir-generator.api';

@Injectable({ providedIn: 'root' })
export class IrGeneratorService {
  private readonly _api = inject(IrGeneratorApi);

  public generateResponse(prompt: string): Observable<string> {
    return this._api.generateResponse(prompt);
  }
}
